import React from "react";
import { Button, Dialog, DialogTitle } from "@material-ui/core";
import { getServerUri } from "../modules/uriUtility";
import { makeStyles } from "@material-ui/core/styles";

const useClasses = makeStyles({
  dialogDelete: {
    margin: 10,
  },
});
/**
 *
 * @param {Boolean} props.isOpen is it open?
 * @param {Function} props.setIsOpen set is open to true or false
 * @param props.images
 * @param props.setImages
 * @param props.createSnackbar
 * @param props.selectImage
 * @param props.deleteImageSetFromMedia
 * @param props.imageSetToDelete
 * @returns {JSX.Element}
 */
export default function dialogImageSetDelete(props) {
  const classes = useClasses();
  return (
    <Dialog
      open={props.isOpen}
      onClose={() => {
        props.setIsOpen(false);
      }}
    >
      <DialogTitle>Delete image?</DialogTitle>
      <div className={classes.dialogDelete}>
        <Button
          label={"OK"}
          onClick={(event) => {
            const newImages = props.images.filter((img) => img.imageSet !== props.imageSetToDelete);
            fetch(getServerUri("media/deleteImageSet"), {
              method: "DELETE",
              headers: {
                "content-type": "application/x-www-form-urlencoded",
              },
              body: new URLSearchParams({
                accessToken: localStorage.getItem("session.accessToken"),
                imageSetID: props.imageSetToDelete,
              }),
            })
              .then((response) => {
                if (response.status === 200) {
                  props.deleteImageSetFromMedia(props.imageSetToDelete);
                  props.setImages(newImages);
                  console.log("deleted image set");
                } else {
                  response
                    .text()
                    .then((responseText) => {
                      console.log(responseText);
                    })
                    .catch(console.error);
                }
              })
              .catch((err) => {
                console.log("fetch error");
                console.error(err);
                props.createSnackbar("An error occurred deleting the image.", "error");
              });
            props.setIsOpen(false);
          }}
        >
          OK
        </Button>
        <Button
          label={"Cancel"}
          onClick={() => {
            props.setIsOpen(false);
          }}
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  );
}
